import React from 'react';
import Cart from '../components/cart/Cart';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const CartPage: React.FC = () => {
  const { user, status } = useAuth();

  // If not logged in, redirect to login
  if (status !== 'loading' && !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
      <Cart />
    </div>
  );
};

export default CartPage;